function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var dist = createCommonjsModule(function (module, exports) {
var l=Object.defineProperty;var P=t=>l(t,"__esModule",{value:!0});var T=(t,e)=>{for(var r in e)l(t,r,{get:e[r],enumerable:!0});};P(exports);T(exports,{getDiff:()=>S});var O;(function(o){o.ADDITION="ADDITION",o.REMOVAL="REMOVAL",o.CHANGE="CHANGE";})(O||(O={}));var x=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),d=t=>Boolean(Object.keys(t).length),u=t=>Boolean(t&&typeof t=="object"),h=(t,e)=>e.reduce((r,o)=>r==null?void 0:r[o],t),M=t=>t[t.length-1];function b(t,e,r=""){let o={},s=[];for(let n in t){let f=r+n,a=t[n],i=e[n];if(!x(e,n))o[n]=t[n],s.push(f);else if(u(a)&&u(i)){let[p,c]=b(a,i,f+".");d(p)&&(o[n]=p),c.size&&s.push(...c);}else a!==i&&(o[n]=a,s.push(f));}return [o,new Set(s)]}function m(t,e){return new Set([...t].filter(r=>e.has(r)))}function j(t,e){return new Set([...t].filter(r=>!e.has(r)))}function D(t,e,r,o){var n;let s=new Map;for(let f of o){let a=f.split("."),i=h(e,a),p=h(t,a),c=(n=a[1])!=null?n:M(a);s.set(f,{type:r,propPath:f,propName:c,value:{before:i,after:p}});}return s}function A(t,e){let[r,o]=t,[s,n]=e,f=m(o,n),a=j(o,f),i=j(n,f),p=D(r,s,O.ADDITION,a),c=D(r,s,O.REMOVAL,i),g=D(r,s,O.CHANGE,f);return {additions:p,removals:c,changes:g}}function S(t,e){let r=b(t,e),o=b(e,t);return A(r,o)}
});

var getDiff = dist.getDiff;
export { getDiff };
